import React from "react";
import Images from "./Images";

import shield from "../../../public/static/images/svg/SVGshield.svg";

export const TableComponent = ({
  table,
  width1,
  mobileWidth1,
  width2,
  mobileWidth2
}) => {
  return (
    <div>
      {table.map((data, key) => {
        return (
          <div className="div1" key={key}>
            {data.title ? (
              <div
                className="col1"
                style={
                  table[1].title === data.title
                    ? { borderRadius: "10px 10px 0 0" }
                    : { borderRadius: "0px" } &&
                      table[table.length - 1].title === data.title
                    ? { borderRadius: "0 0 10px 10px" }
                    : { borderRadius: "0px" }
                }
              >
                {data.title}
              </div>
            ) : (
              <div></div>
            )}
            {data.title ? (
              <div className="col2">
                {data.table1 ? (
                  <Images width="48px" mobileWidth="28px" url={shield}></Images>
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </div>
            ) : (
              <div className="img">
                <Images
                  width={width1}
                  mobileWidth={mobileWidth1}
                  url={data.image1}
                ></Images>
                <p>{data.title1}</p>
              </div>
            )}
            {data.title ? (
              <div
                className="col3"
                style={
                  table[1].title === data.title
                    ? { borderRadius: "10px 10px 0 0" }
                    : { borderRadius: "0px" } &&
                      table[table.length - 1].title === data.title
                    ? { borderRadius: "0 0 10px 10px" }
                    : { borderRadius: "0px" }
                }
              >
                {data.table2 ? (
                  <Images width="48px" mobileWidth="28px" url={shield}></Images>
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </div>
            ) : (
              <div className="img">
                <Images
                  width={width2}
                  mobileWidth={mobileWidth2}
                  url={data.image2}
                ></Images>
                <p>{data.title2}</p>
              </div>
            )}
          </div>
        );
      })}
      <style jsx>{`
        .img {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-weight: bold;
        }
        .div1 {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        }
        .col1 {
          padding: 16px;
          display: flex;
          align-items: center;
          font-weight: bold;
        }
        .col1 {
          background-color: var(--color-gray-lightest);
        }
        .col2 {
          display: flex;
          justify-content: center;
          text-align: center;
          padding: 16px;
        }
        .col3 {
          display: flex;
          justify-content: center;
          text-align: center;
          padding: 16px;
          background-color: var(--color-gray-lightest);
        }
        @media only screen and (max-width: 600px) {
          .div1 {
            grid-template-columns: 2fr 1fr 1fr;
          }
          .col1 {
            font-size: 12px;
          }
          .col2 {
            padding: 8px;
          }
          .col3 {
            padding: 8px;
          }
          .img {
            font-size: 10.5px;
          }
        }
      `}</style>
    </div>
  );
};
